import {authHeader, ApiConfigs} from "../_helpers";
import { authService } from "./auth.service";

// import store from '@/store';

export const customerService = {
    getAll,
    store,
    update,
    delete: _delete,
    filter,
    searchWithoutPagination,
    searchWithFullParams,
    show
};

function searchWithoutPagination(key : string , value:string  ) {
    const requestOptions = {
        credentials : 'include' as RequestCredentials,
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.customer.getAll}?key=${key}&value=${value}`, requestOptions).then(handleResponse);
}

function searchWithFullParams(key : string , value:string , currentPage:any , page:any ) {
    const requestOptions = {
        credentials : 'include' as RequestCredentials,
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.customer.getAll}?key=${key}&value=${value}&page=${currentPage}&per_page=${page}`, requestOptions).then(handleResponse);
}




function getAll(currentPage : number , perPage:number ) {
    const requestOptions = {
        credentials : 'include' as RequestCredentials,
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.customer.getAll}?per_page=${perPage}&page=${currentPage}`, requestOptions).then(handleResponse);
}

function show(id: string) {
    const requestOptions = {
        method: "GET",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" }, 
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.customer.show.replace(':id', id)}`, requestOptions)
        .then(
            handleResponse
        );
}


function filter(key:string, value:string){
    const requestOptions = {
        credentials : 'include' as RequestCredentials,
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`${ApiConfigs.base_url+ApiConfigs.customer.getAll}?key=${key}&value=${value}`, requestOptions).then(handleResponse);
}

function store(payload: object) {
    const requestOptions = {
        credentials : 'include' as RequestCredentials,
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.customer.store}`, requestOptions).then(handleResponse);
}

function update(id: string, payload: object) {
    const requestOptions = {
        credentials : 'include' as RequestCredentials,
        method: 'PUT',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.customer.update.replace(':id', id)}`, requestOptions).then(handleResponse);
}

function _delete(id: string) {
    const requestOptions = {
        credentials : 'include' as RequestCredentials,
        method: 'DELETE',
        headers: authHeader()
    };

    return fetch(`${ApiConfigs.base_url+ApiConfigs.customer.delete.replace(':id', id)}`, requestOptions).then(handleResponse);
}


function handleResponse(response: any) {
    return response.text().then((text: string) => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                localStorage.removeItem('user');
                localStorage.removeItem("store");

                location.reload();
                authService.logout();
            }
            const error = (data && data.message) || response.status || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}
